import { resetIdleDeadline } from '../../utils/idle-timer'

export const EHR_AUTH_PROVIDER = 'ehr'
export const EHR_PATIENT_ID_KEY = 'ehr_patient_id'

export const isEhrLaunchEnabled = () =>
  process.env.REACT_APP_FEATURE_TOGGLE_EHR_LAUNCH_ENABLED === 'true'

export const isEhrAuthSession = () =>
  isEhrLaunchEnabled() &&
  localStorage.getItem('auth_provider') === EHR_AUTH_PROVIDER &&
  !localStorage.getItem('refresh_token') &&
  !localStorage.getItem('client_id')

export const clearEhrLaunchStorage = () => {
  localStorage.removeItem('auth_provider')
  localStorage.removeItem(EHR_PATIENT_ID_KEY)
}

export const clearCurrentEhrAuthStorage = (preserveSharedEhrSession = false) => {
  if (preserveSharedEhrSession) return
  const isDedicatedEhrSession = isEhrAuthSession()
  clearEhrLaunchStorage()
  if (!isDedicatedEhrSession) return
  localStorage.removeItem('access_token')
  localStorage.removeItem('prescriber')
  localStorage.removeItem('admin')
  localStorage.removeItem('permissions')
  localStorage.removeItem('user_id')
}

export const clearAllAuthStorage = () => {
  localStorage.removeItem('access_token')
  localStorage.removeItem('refresh_token')
  localStorage.removeItem('id_token')
  localStorage.removeItem('prescriber')
  localStorage.removeItem('admin')
  localStorage.removeItem('permissions')
  localStorage.removeItem('email')
  localStorage.removeItem('username')
  localStorage.removeItem('client_id')
  localStorage.removeItem('user_id')
  clearEhrLaunchStorage()
  // An EHR launch establishes a brand new session, so it must not inherit the
  // idle deadline of whatever session was in this browser before it.
  resetIdleDeadline()
}
